import { render, staticRenderFns } from "./SMAZgbTeamMembersList.vue?vue&type=template&id=0ae05347"
import script from "./SMAZgbTeamMembersList.vue?vue&type=script&lang=js"
export * from "./SMAZgbTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./SMAZgbTeamMembersList.vue?vue&type=style&index=0&id=0ae05347&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports